<template>
  <div :class="{'code_button':true, 'disabled': btnDisabled || disabled}" @click="handleClick">
    {{mainValue}}
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'CodeButton',
  props: {
    sKey: {
      type: [String, Number],
      default: ''
    },
    startCountDown: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    remember: { // 倒计时是否带记忆功能(即倒计时过程中刷新页面后是否继续上一次的倒计时)
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mainValue: '发送验证码',
      btnDisabled: false,
      ss: 60,
      tt: null
    }
  },
  watch: {
    startCountDown (s) {
      if (s) this.countSeconds(s)
      else this.resetTime()
    }
  },
  beforeDestroy () {
    clearInterval(this.tt)
  },
  mounted () {
    if (this.sKey) {
      const preC = Number(sessionStorage.getItem('$count' + this.sKey))
      if (this.remember && preC) {
        const cur = moment().valueOf()
        const passdur = parseInt(moment.duration(cur - preC, 'ms').asSeconds())
        if (passdur < 60) {
          this.btnDisabled = false
          this.ss = 60 - passdur
          this.countSeconds(false)
        }
      }
    }
  },
  methods: {
    handleClick () {
      if (!this.disabled && !this.btnDisabled) this.$emit('smsBtnClick')
    },
    countSeconds (toSet) {
      if (!this.btnDisabled) {
        this.btnDisabled = true
        this.mainValue = this.ss + 's'
        if (toSet && this.sKey) sessionStorage.setItem('$count' + this.sKey, moment().valueOf())
        this.tt = setInterval(() => {
          this.ss--
          this.mainValue = this.ss + 's'
          if (this.ss === 0) {
            if (this.sKey) sessionStorage.removeItem('$count' + this.sKey) // 60秒倒计时结束清除session中的时间信息
            this.resetTime()
          }
        }, 1000)
      }
    },
    resetTime () {
      clearInterval(this.tt)
      this.btnDisabled = false
      this.ss = 60
      this.mainValue = '发送验证码'
      this.$emit('update:startCountDown', false)
    }
  }
}
</script>

<style lang="sass">
.code_button
  width: 120px
  height: 30px
  color: #fff
  font-size: 14px
  text-align: center
  line-height: 30px
  background: $main-gradient
  border-radius: 4px
  cursor: pointer
  &.disabled
    background: #D4D4D4
    cursor: default
</style>